import { useMemo } from 'react'
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined'
import useSharedCollection from '../../firebase/useSharedCollection'
import { sortLocations } from '../../helpers/locations/locationFilter'

const DashboardLocationFilter = ({ selectedLocationId, onChange }) => {
    const locations = useSharedCollection('Locations')
    const list = useMemo(() => sortLocations(locations), [locations])

    if (list.length === 0) return null

    if (list.length === 1) {
        return (
            <span className="dashboard-filter-chip dashboard-filter-chip-static">
                <PlaceOutlinedIcon fontSize="small" className="dashboard-filter-chip-icon" />
                <span className="dashboard-filter-chip-label">Locatie:</span>
                <span className="dashboard-filter-chip-value">{list[0].Title}</span>
            </span>
        )
    }

    const handleChange = (e) => onChange(e.target.value)

    return (
        <label className="dashboard-filter-chip">
            <PlaceOutlinedIcon fontSize="small" className="dashboard-filter-chip-icon" />
            <span className="dashboard-filter-chip-label">Locatie:</span>
            <select
                className="dashboard-filter-chip-select"
                value={selectedLocationId || ''}
                onChange={handleChange}
            >
                <option value="">Alle</option>
                {list.map((loc) => (
                    <option key={loc.docid} value={loc.docid}>
                        {loc.Title}
                    </option>
                ))}
            </select>
        </label>
    )
}

export default DashboardLocationFilter
